export default __webpack_public_path__ + "static/media/basic-push-pin-6.9025f632.png";